import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "flex md5" }
const _hoisted_3 = { class: "flex md5" }
const _hoisted_4 = { class: "flex md1" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "flex md6" }
const _hoisted_7 = { class: "mdo-select" }
const _hoisted_8 = { for: "campaign" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "flex md6" }
const _hoisted_11 = { class: "mdo-select" }
const _hoisted_12 = { for: "agent" }
const _hoisted_13 = ["value"]

import { Agent, Campaign, OutsideBookCreateInput, OutsideBookResponse, OutsideBookUpdateInput } from "@/codes/gen/types";
import { AgentService } from "@/codes/services/AgentService";
import { CampaignService } from "@/codes/services/CampaignService";
import { OutsideBookService } from "@/codes/services/OutsideBookService";
import { ReactiveData } from "@/codes/types/MDOTypes";
import { ROUTE_NAMES } from "@/codes/util/constants";
import { Confirm } from "@/codes/util/swalUtil";
import router from "@/router";
import Swal from "sweetalert2";
import { useForm } from "vee-validate";
import { onMounted, reactive, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isEdit = ref(false);
let idOutsideBookEdit = '';
const outsideBook = reactive<ReactiveData<OutsideBookCreateInput>>({ data: { enable: true } as OutsideBookCreateInput });
const campaigns = reactive<ReactiveData<Campaign[]>>({ data: [] as Campaign[] });
const agents = reactive<ReactiveData<Agent[]>>({ data: [] as Agent[] });

const form = useForm();
const formMeta = reactive(form.meta);

const i18n = useI18n();

const loadOutsideBook = async function(id: string) {
  const service = new OutsideBookService();
  const result = await service.getForEdit(id);
  if (result) {
    const book: OutsideBookCreateInput = {
      name: result.name,
      description: result.description,
      agent: result.agent ? result.agent.id : '',
      campaign: result.campaign ? result.campaign.id : '',
      enable: result.enable,
    };

    outsideBook.data = book;
    form.setValues(book);
  }
}

const loadAgents = async function() {
  agents.data = [];
  const agentService = new AgentService();
  const result = await agentService.getAllCombo();
  if (result) {
    result.edges.forEach((r) => {
      agents.data.push(r);
    })
  }
}

const loadCampaigns = async function() {
  campaigns.data = [];
  const campaignService = new CampaignService();
  const result = await campaignService.getAllCombo();
  if (result) {
    result.edges.forEach((r) => {
      campaigns.data.push(r);
    });
  }
}

const save = async function() {
  const validate = await form.validate() as any;
  if (validate.valid) {
    const service = new OutsideBookService();
    const funcConcluir = (result: OutsideBookResponse | null | undefined) => {
      if (result && result.data.id) {
        idOutsideBookEdit = '';
        router.push({ name: ROUTE_NAMES.outsideBooks });
      } else {
        Swal.fire({
          title: i18n.t('genericErrorTitle'),
          text: i18n.t('saveErrorMessage', { register: i18n.t('outsideBook.title'), message: result?.message })
        });
      }
    }
    if (isEdit.value) {
      const outsideBookUpdate: OutsideBookUpdateInput = {
        name: outsideBook.data.name,
        description: outsideBook.data.description,
        enable: outsideBook.data.enable,
        agent: outsideBook.data.agent,
        campaign: outsideBook.data.campaign
      };

      const result = await service.update(idOutsideBookEdit, outsideBookUpdate);
      funcConcluir(result);
    } else {
      const result = await service.create(outsideBook.data);
      funcConcluir(result);
    }
  } else {
    form.setErrors(validate.errors);
  }
}

const cancel = function() {
  if (form.meta.value.dirty) {
    Confirm.fire({
      title: i18n.t('form.confirmCancelTitle'),
      text: i18n.t('form.confirmCancelText')
    })
    .then((result) => {
      if (result.isConfirmed) {
        router.push({ name: ROUTE_NAMES.outsideBooks });
      }
    });
  } else {
    router.push({ name: ROUTE_NAMES.outsideBooks });
  }
}

onMounted(async () => {
  const route = useRoute();
  loadAgents();
  loadCampaigns();

  if (route && route.name === ROUTE_NAMES.editOutsideBook) {
    idOutsideBookEdit = route.params.id as string;
    loadOutsideBook(idOutsideBookEdit);
    isEdit.value = true;
  }
})


return (_ctx: any,_cache: any) => {
  const _component_va_input = _resolveComponent("va-input")!
  const _component_VField = _resolveComponent("VField")!
  const _component_va_switch = _resolveComponent("va-switch")!
  const _component_base_form = _resolveComponent("base-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_base_form, {
      "form-meta": _unref(formMeta),
      onSave: save,
      onCancel: cancel
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_VField, {
              name: "name",
              rules: 'required|min:3'
            }, {
              default: _withCtx(({ field, errors: nameErrors }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(outsideBook).data.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_unref(outsideBook).data.name = $event)),
                  class: "mb-4",
                  label: _ctx.$t('register.name'),
                  error: nameErrors && nameErrors.length > 0,
                  "error-messages": nameErrors
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_VField, {
              name: "description",
              rules: 'min:5'
            }, {
              default: _withCtx(({ field, errors: descriptionError }) => [
                _createVNode(_component_va_input, _mergeProps(field, {
                  modelValue: _unref(outsideBook).data.description,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_unref(outsideBook).data.description = $event)),
                  type: "textarea",
                  class: "mb-4",
                  label: _ctx.$t('register.description'),
                  error: descriptionError && descriptionError.length > 0,
                  "error-messages": descriptionError
                }), null, 16, ["modelValue", "label", "error", "error-messages"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_VField, { name: "enable" }, {
              default: _withCtx(({ field }) => [
                _createVNode(_component_va_switch, _mergeProps(field, {
                  modelValue: _unref(outsideBook).data.enable,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_unref(outsideBook).data.enable = $event)),
                  "true-inner-label": _ctx.$t('form.enabled'),
                  "false-inner-label": _ctx.$t('form.disabled'),
                  class: "mr-4"
                }), null, 16, ["modelValue", "true-inner-label", "false-inner-label"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('campaign.title')), 1),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_unref(outsideBook).data.campaign = $event)),
                name: "campaign"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(campaigns).data, (op) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: op.id,
                    value: op.id
                  }, _toDisplayString(op.name), 9, _hoisted_9))
                }), 128))
              ], 512), [
                [_vModelSelect, _unref(outsideBook).data.campaign]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('agent.title')), 1),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_unref(outsideBook).data.agent = $event)),
                name: "agent"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(agents).data, (op) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: op.id,
                    value: op.id
                  }, _toDisplayString(op.name), 9, _hoisted_13))
                }), 128))
              ], 512), [
                [_vModelSelect, _unref(outsideBook).data.agent]
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["form-meta"])
  ]))
}
}

})